import React from "react";
import { useTranslation } from "react-i18next";
import useRevealOnScroll from "../hooks/useRevealOnScroll";

const logos = [
  { src: require('../images/partners/cisco.png'), link: 'https://www.cisco.com/' },
  { src: require('../images/partners/magos.png'), link: 'https://magossystems.com/' },
  { src: require('../images/partners/rajant.png'), link: 'https://www.rajant.com/' },
  { src: require('../images/partners/hytera.png'), link: 'https://www.hytera.com/' },
  { src: require('../images/partners/motorola.png'), link: 'https://www.motorolasolutions.com/' },
  { src: require('../images/partners/pelco.png'), link: 'https://www.pelco.com/' },
  { src: require('../images/partners/avigilon.png'), link: 'https://www.avigilon.com/' },
  { src: require('../images/partners/milestone.png'), link: 'https://www.milestonesys.com/' },
  { src: require('../images/partners/briefcam.png'), link: 'https://www.briefcam.com/' },
  { src: require('../images/partners/polycom.png'), link: 'https://www.poly.com/' },
  { src: require('../images/partners/logo-infinet.png'), link: 'https://infinetwireless.com/' },
  { src: require('../images/partners/logo.png'), link: 'https://taip.su/' },
  { src: require('../images/partners/balt.png'), link: 'https://baltinfocom.ru/' },
  { src: require('../images/partners/set.png'), link: 'https://www.set-1.ru/' },
  { src: require('../images/partners/parsec.png'), link: 'https://www.parsec.ru/' },
  { src: require('../images/partners/asia.png'), link: 'https://asia-soft.kz/' },

  { src: require('../images/partners/dell.png'), link: 'https://www.dell.com/' },
  // { src: require('../images/partners/svc.svg'), link: 'https://svc.kz/' },
  { src: require('../images/partners/huawei.png'), link: 'https://www.huawei.com/' },
  { src: require('../images/partners/samsung.png'), link: 'https://www.samsung.com/' },
  { src: require('../images/partners/bolid.jpg'), link: 'https://www.bolid.ru/' },
  { src: require('../images/partners/recfaces.png'), link: 'https://recfaces.com/' },
  // { src: require('../images/partners/vaxtor.svg'), link: 'https://vaxtor.com/' },
  { src: require('../images/partners/forti.png'), link: 'https://www.fortinet.com/' },
  { src: require('../images/partners/geek.png'), link: 'https://geeklink.com.cn/' }, // если другой — уточни
  // { src: require('../images/partners/signatek.svg'), link: 'https://signatek.kz/' },
  { src: require('../images/partners/wds.png'), link: 'https://wds.kz/' },
  { src: require('../images/partners/elco.jpg'), link: 'https://elco.kg/' }, // уточни страну, если это не Кыргызстан
  { src: require('../images/partners/ko.png'), link: 'https://kontur-systems.kz/' }, // или твой сайт
  { src: require('../images/partners/sibir.png'), link: 'https://sibirtelecom.ru/' }, // уточни точное название
  { src: require('../images/partners/lg.png'), link: 'https://www.lg.com/' },
  { src: require('../images/partners/ace6.png'), link: 'https://www.ace6.com.sg/' },
  { src: require('../images/partners/alan.png') },
];

  
  


export default function Partners() {
  const { t } = useTranslation('partners');
  const [revealRef, isVisible] = useRevealOnScroll();

  const renderLogo = (partner, key) => {
    // Фикс. рамка одинакового размера для всех логотипов — иначе широкие
    // wordmark'и (Fortinet, Dell) и высокие бейджи (Huawei, Motorola)
    // выглядят вразнобой. object-contain внутри вписывает каждый по своим
    // пропорциям, не искажая.
    const logoImg = (
      <div className="w-32 h-16 sm:w-36 sm:h-16 flex items-center justify-center rounded-xl bg-white p-3 shadow-[0_8px_24px_-6px_rgba(0,0,0,0.45)]">
        <img
          src={partner.src}
          alt="partner logo"
          className="max-w-full max-h-full w-auto h-auto object-contain grayscale opacity-90 hover:grayscale-0 hover:opacity-100 transition duration-300"
        />
      </div>
    );

    return partner.link ? (
      <a
        href={partner.link}
        key={key}
        target="_blank"
        rel="noopener noreferrer"
        className="shrink-0 px-4 hover:scale-105 transition-transform"
      >
        {logoImg}
      </a>
    ) : (
      <div key={key} className="shrink-0 px-4 hover:scale-105 transition-transform">
        {logoImg}
      </div>
    );
  };

  return (
    <section id="partners" className="relative bg-[#0a111f] py-16 scroll-mt-20 overflow-hidden">
      <div
        ref={revealRef}
        className={`reveal max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ${isVisible ? 'is-visible' : ''}`}
      >
        <h2 className="anchor-offset font-display text-4xl font-bold text-white text-center">
          {t('title')}
        </h2>
        <span className={`title-accent center mb-12 ${isVisible ? 'is-visible' : ''}`} />
      </div>

      {(() => {
        const mid = Math.ceil(logos.length / 2);
        const rowTop = logos.slice(0, mid);
        const rowBottom = logos.slice(mid);
        const maskStyle = {
          WebkitMaskImage: 'linear-gradient(90deg, transparent, black 8%, black 92%, transparent)',
          maskImage: 'linear-gradient(90deg, transparent, black 8%, black 92%, transparent)',
        };
        return (
          <div
            className={`reveal-soft space-y-6 ${isVisible ? 'is-visible' : ''}`}
            style={{ transitionDelay: '150ms' }}
          >
            <div className="w-full" style={maskStyle}>
              <div className="marquee-track animate-marquee items-center">
                {rowTop.map((partner, idx) => renderLogo(partner, `top-a-${idx}`))}
                {rowTop.map((partner, idx) => renderLogo(partner, `top-b-${idx}`))}
              </div>
            </div>
            <div className="w-full" style={maskStyle}>
              <div className="marquee-track animate-marquee [animation-direction:reverse] items-center">
                {rowBottom.map((partner, idx) => renderLogo(partner, `bot-a-${idx}`))}
                {rowBottom.map((partner, idx) => renderLogo(partner, `bot-b-${idx}`))}
              </div>
            </div>
          </div>
        );
      })()}
    </section>
  );
}
